import { useState, useEffect } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const AncestorOffset = {
  mobile: 24,
  nonMobile: 20,
} as const

export const useOffset = () => {
  const [offset, setOffset] = useState<24 | 20>(AncestorOffset.mobile)
  const { isMobile } = useResponsiveDesign()
  useEffect(() => {
    setOffset(isMobile ? AncestorOffset.mobile : AncestorOffset.nonMobile)
  }, [isMobile])

  return offset
}
